import { Component } from "react";
import { Link } from "react-router-dom";
import Header from "../components/header";
import Footer from "../components/footer";

import "../styles/auth.css";

class SignUp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fullName: "",
      email: "",
      password: "",
      confirmPassword: "",
      errorMessage: "",
      successMessage: "",
      isLoading: false,
    };
  }

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
      errorMessage: "",
      successMessage: "",
    });
  };

  handleSubmit = async (e) => {
    e.preventDefault();

    const { fullName, email, password, confirmPassword } = this.state;

    // Check 1: No empty fields
    if (
      !fullName.trim() ||
      !email.trim() ||
      !password.trim() ||
      !confirmPassword.trim()
    ) {
      this.setState({ errorMessage: "Please fill in all fields completely." });
      return;
    }

    // Check 2: Valid email format (must have @ and a dot after it)
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      this.setState({ errorMessage: "Please enter a valid email address." });
      return;
    }

    // Check 3: Password must be at least 8 characters
    if (password.length < 8) {
      this.setState({
        errorMessage: "Your password must be at least 8 characters long.",
      });
      return;
    }

    // Check 4: Both passwords must match exactly
    if (password !== confirmPassword) {
      this.setState({
        errorMessage: "Passwords do not match. Please try again.",
      });
      return;
    }

    // Show loading state on the button, disable it to prevent double-clicks
    this.setState({ isLoading: true });

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/user/signup`,
        {
          method: "POST", // POST to save data
          //headers confirm if the data is changed to json
          headers: {
            "Content-Type": "application/json",
          },

          // body is the actual data being sent
          body: JSON.stringify({
            name: fullName,
            email: email,
            password: password,
            // NOTE: confirm password is not backend, its a frontend check
          }),
        },
      );

      // read and parse the JSON response that Flask sent back. success - good, fail - bad
      const data = await response.json();

      if (data.success) {
        // Show a green success message and redirect to login after 2 seconds
        this.setState({
          successMessage:
            "Account created successfully! Redirecting to login :)",
          fullName: "",
          email: "",
          password: "",
          confirmPassword: "",
        });

        setTimeout(() => {
          window.location.href = "/login_screen";
        }, 2000); // wait 2 seconds so the user can read the success message
      } else {
        // Examples: "Email already exists", "Missing fields"
        // Show that exact message from Flask in the error box.
        this.setState({ errorMessage: data.message });
      }
    } catch (error) {
      //when backend doesn't work
      this.setState({
        errorMessage:
          "Could not connect to the server. Please make sure the backend is running.",
      });
    } finally {
      // This block ALWAYS runs whether the request succeeded or failed.
      // It turns off the loading state so the button becomes clickable again.
      this.setState({ isLoading: false });
    }
  };

  render() {
    return (
      <div className="d-flex flex-column min-vh-100 bg-light">
        <Header />

        <main className="flex-grow-1 d-flex justify-content-center align-items-center py-5">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-12 col-md-8 col-lg-5">
                <div className="card shadow-sm border-0 rounded-4 auth-card">
                  <div className="card-body p-4 p-md-5">
                    <div className="text-center mb-4">
                      <h2 className="fw-bold text-dark mb-2">
                        Create an Account
                      </h2>
                    </div>

                    {/* Only shows when errorMessage has text in it - uses bs*/}
                    {this.state.errorMessage && (
                      <div
                        className="alert alert-danger py-2"
                        style={{ fontSize: "14px" }}
                        role="alert"
                      >
                        {this.state.errorMessage}
                      </div>
                    )}

                    {/* Only shows when successMessage has text in it - uses bs*/}
                    {this.state.successMessage && (
                      <div
                        className="alert alert-success py-2"
                        style={{ fontSize: "14px" }}
                        role="alert"
                      >
                        {this.state.successMessage}
                      </div>
                    )}

                    <form onSubmit={this.handleSubmit}>
                      {/* FULL NAME */}
                      <div className="mb-3">
                        <label className="form-label fw-medium text-dark">
                          Full Name
                        </label>
                        <input
                          type="text"
                          name="fullName"
                          className="form-control form-control-lg bg-light custom-input"
                          placeholder="Full Name"
                          value={this.state.fullName}
                          onChange={this.handleChange}
                          disabled={this.state.isLoading} // Disable inputs while submitting
                        />
                      </div>

                      {/* EMAIL */}
                      <div className="mb-3">
                        <label className="form-label fw-medium text-dark">
                          Email Address
                        </label>
                        <input
                          type="email"
                          name="email"
                          className="form-control form-control-lg bg-light custom-input"
                          placeholder="name@example.com"
                          value={this.state.email}
                          onChange={this.handleChange}
                          disabled={this.state.isLoading}
                        />
                      </div>

                      {/* PASSWORD */}
                      <div className="mb-3">
                        <label className="form-label fw-medium text-dark">
                          Password
                        </label>
                        <input
                          type="password"
                          name="password"
                          className="form-control form-control-lg bg-light custom-input"
                          placeholder="Password"
                          value={this.state.password}
                          onChange={this.handleChange}
                          disabled={this.state.isLoading}
                        />
                      </div>

                      {/* CONFIRM PASSWORD */}
                      <div className="mb-4">
                        <label className="form-label fw-medium text-dark">
                          Confirm Password
                        </label>
                        <input
                          type="password"
                          name="confirmPassword"
                          className="form-control form-control-lg bg-light custom-input"
                          placeholder="Re-enter Password"
                          value={this.state.confirmPassword}
                          onChange={this.handleChange}
                          disabled={this.state.isLoading}
                        />
                      </div>

                      {/* SUBMIT BUTTON */}
                      {/* Changes text to "Creating Account..." while loading */}
                      {/* Disabled while loading to prevent double submissions */}
                      <button
                        type="submit"
                        className="btn btn-brand btn-lg w-100 mb-3"
                        disabled={this.state.isLoading}
                      >
                        {this.state.isLoading
                          ? "Creating Account..."
                          : "Sign Up"}
                      </button>

                      <div className="text-center">
                        <span className="text-secondary">
                          Already have an account?{" "}
                        </span>
                        <Link
                          to="/login_screen"
                          className="text-brand text-decoration-none fw-medium"
                        >
                          Log in
                        </Link>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>

        <Footer />
      </div>
    );
  }
}

export default SignUp;
